import { useState } from 'react';
import { Alert, App, Button, Card, Space, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { membershipApi } from '../api/membershipApi';
import { MembershipForm } from '../components/MembershipForm';
import { membershipErrorMessage } from '../utils/errors';
import {
  toCreateMembershipBody,
  type MembershipFormValues,
} from '../utils/membershipForm';

/**
 * Página de alta de Membresía (`/membresias/nueva`, solo `SUPER_ADMIN` — el guard
 * de la ruta lo garantiza). La membresía nace mensual y activa, con moneda COP.
 */
export function CreateMembershipPage() {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const goToList = () => navigate('/membresias');

  const handleSubmit = async (values: MembershipFormValues) => {
    setSubmitting(true);
    setError(null);
    try {
      const created = await membershipApi.create(toCreateMembershipBody(values));
      message.success('Membresía creada.');
      navigate(`/membresias/${encodeURIComponent(created.id)}`);
    } catch (caught) {
      setError(
        membershipErrorMessage(caught, 'No se pudo crear la membresía.'),
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="membresias-page">
      <div className="membresias-page__header">
        <Space align="center">
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            aria-label="Volver al listado de membresías"
            onClick={goToList}
          >
            Volver
          </Button>
          <Typography.Title level={3} style={{ margin: 0 }}>
            Nueva membresía
          </Typography.Title>
        </Space>
      </div>

      {error && (
        <Alert
          type="error"
          showIcon
          role="alert"
          message="No se pudo crear la membresía"
          description={error}
        />
      )}

      <Card>
        <MembershipForm
          mode="create"
          submitting={submitting}
          onSubmit={handleSubmit}
          onCancel={goToList}
        />
      </Card>
    </div>
  );
}
